export enum EnumEmployeeCardState {
  Loading = 'loading',
  Ready = 'ready',
  Saving = 'saving',
  Error = 'error',
}
